import { Box, ButtonBase } from '@material-ui/core';
import { AddCircle, Folder } from '@material-ui/icons';
import React, { FC, useState } from 'react';
import { getConfig } from '../../../config/config';
import { useLanguage } from 'languages/languageContext';
import DefaultModal from 'components/Shared/DefaultModal';

export const AddFolder: FC<{ currentPath: any; showFoldersModal: () => void; disabled: boolean }> = (props) => {
  const { documentsScreen } = useLanguage();
  const [showWarning, setShowWarning] = useState(false);
  const handleClick = () => {
    if (props.disabled) {
      setShowWarning(true);
    } else {
      props.showFoldersModal();
    }
  };
  return (
    <>
      <ButtonBase onClick={handleClick}>
        {/* <Icon name='folder' size={32} color={theme.BUTTON_PRIMARY} /> */}
        <Folder style={{ color: theme.BUTTON_PRIMARY, width: 32, height: 32 }} />
        <Box
          style={{
            position: 'absolute',
            backgroundColor: theme.BACKGROUND_PRIMARY,
            width: 24,
            height: 24,
            borderRadius: 24,
            right: -7,
            top: 10,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AddCircle style={{ color: theme.BUTTON_PRIMARY, width: 24, height: 24 }} />
        </Box>
      </ButtonBase>
      <DefaultModal
        showModal={showWarning}
        onClose={() => setShowWarning(false)}
        modalTitle={documentsScreen.onlyAdminsCanUploadTitle}
        message={documentsScreen.onlyAdminsCanCreateFoldersMessage}
        children={null}
      />
    </>
  );
};
const { config, theme } = getConfig();
